var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [_vm._v("Add Accounts")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "app-filter-good-table-container" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-5"
              },
              [
                _c(
                  "b-list-group",
                  [
                    _c(
                      "b-list-group-item",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.socialAccount("facebook")
                          }
                        }
                      },
                      [
                        _c("b-img", {
                          staticStyle: {
                            height: "50px",
                            width: "50px",
                            "margin-right": "10px"
                          },
                          attrs: {
                            src: "/static/images/fb.png",
                            rounded: "circle",
                            alt: "Card with Image"
                          }
                        }),
                        _vm._v(
                          "\n                       Facebook\n                 "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.socialAccount("linkedin")
                          }
                        }
                      },
                      [
                        _c("b-img", {
                          staticStyle: {
                            height: "50px",
                            width: "50px",
                            "margin-right": "10px"
                          },
                          attrs: {
                            src: "/static/images/linkedin.png",
                            rounded: "circle",
                            alt: "Card with Image"
                          }
                        }),
                        _vm._v(
                          "\n                       LinkedIn\n                "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.socialAccount("twitter")
                          }
                        }
                      },
                      [
                        _c("b-img", {
                          staticStyle: {
                            height: "50px",
                            width: "50px",
                            "margin-right": "10px"
                          },
                          attrs: {
                            src: "/static/images/twitter.png",
                            rounded: "circle",
                            alt: "Card with Image"
                          }
                        }),
                        _vm._v(
                          "\n                    Twitter\n                 "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-list-group-item",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.socialAccount("instagram")
                          }
                        }
                      },
                      [
                        _c("b-img", {
                          staticStyle: {
                            height: "50px",
                            width: "50px",
                            "margin-right": "10px"
                          },
                          attrs: {
                            src: "/static/images/insta.jpeg",
                            rounded: "circle",
                            alt: "Card with Image"
                          }
                        }),
                        _vm._v(
                          "\n                      Instagram\n                  "
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
        [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-736d89a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736d89a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/socialmedia/addAccount.vue
// module id = null
// module chunks = 